import React, { useMemo } from 'react'

import { MAX_MENU_HEIGHT } from 'cube'
import { equals } from 'ramda'

import { type SelectOption, Select } from '@driftt/dds'

import { TEMPORAL_AVAILABLE_LANGUAGES } from './constants'

interface LanguageCodeSelectProps {
  selectedLanguageCodes: string[]
  isDisabled: boolean
  onChange: (languageCodes: string[]) => void
}

export const LanguageCodeSelect = ({
  selectedLanguageCodes = [],
  isDisabled,
  onChange,
}: LanguageCodeSelectProps) => {
  const SelectedCountryOptions = useMemo(
    () =>
      selectedLanguageCodes.map((langCode: string) =>
        TEMPORAL_AVAILABLE_LANGUAGES.find((languageOption) =>
          equals(languageOption.value, langCode)
        )
      ),
    [selectedLanguageCodes]
  )

  return (
    <Select
      multi
      allowSelectAll
      label="Select language codes"
      placeholder="Select..."
      hideLabel
      options={TEMPORAL_AVAILABLE_LANGUAGES}
      value={SelectedCountryOptions}
      onChange={(options) => {
        const selectedOptions = options as SelectOption<string>[]
        const selectedValues = selectedOptions.map((option) => option.value)
        onChange(selectedValues)
      }}
      isDisabled={isDisabled}
      maxMenuHeight={MAX_MENU_HEIGHT}
    />
  )
}
